/* tslint:disable:no-console */

import { register, unregister } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  unregister()
  // register(`${process.env.BASE_URL}service-worker.js`, {
  //   ready() {
  //     console.log(
  //       'App is being served from cache by a service worker.\n' +
  //       'For more details, visit https://goo.gl/AFskqB'
  //     )
  //   },
  //   registered() {
  //     console.log('Service worker has been registered.')
  //   },
  //   cached() {
  //     console.log('Content has been cached for offline use.')
  //   },
  //   updatefound() {
  //     console.log('New content is downloading.')
  //   },
  //   updated() {
  //     console.log('New content is available; please refresh.')
  //     // setTimeout(() => {
  //     //   window.location.reload()
  //     // }, 1000)
  //   },
  //   offline() {
  //     console.log('No internet connection found. App is running in offline mode.')
  //     console.log('offline test')
  //   },
  //   error(error) {
  //     console.error('Error during service worker registration:', error)
  //   }
  // })
}
